<template>
  <div id="app">
    <!-- <homepage /> -->
    <router-view />
    <!-- ⚠️ 备案号原来写的是 width:100% + bottom:0，等于在视口最底部铺了一条「通栏的透明层」，
         它正好压在内容区（el-main）的横向滚动条上，把鼠标事件全吃掉了
         → 悬停没反应、拖不动（滚动条还在，只是点不到）。
         改法：宽度只包住文字本身 + bottom 抬到滚动条上方 + pointer-events:none，
         这样它既挡不到横向滚动条，也挡不到右侧纵向滚动条的底端。 -->
    <div
      style="
        position: fixed;
        text-align: left;
        bottom: 5px;
        left: 5px;
        margin: 0px;
        width: auto;
        font-size: 10px;
        color:rgba(169, 169, 169, 0.5);
        pointer-events: none;
      "
    >
      <span>渝ICP备18007262号-1</span>
    </div>
  </div>
</template>
<script>
import homepage from './components/homepage.vue';

export default {
  name: 'app',
  components: {
    homepage
  },
  mounted() {
    console.log('页面已被刷新', this.$router);
    let path = this.$router.history.current.path;
    this.$EventBus.$emit('currentPath', path);
  }
};
</script>
<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
</style>
